import React, { useState, useEffect } from 'react';
import whatsapp from '../images/whatsapp.png';
import { Link } from 'react-router-dom';

// Images
import img1 from '../images/img1.jpg';
import img2 from '../images/img2.jpg';
import img3 from '../images/img3.jpg';
import img4 from '../images/img4.jpg';
import img5 from '../images/img5.jpg';
import img6 from '../images/img6.jpg';
import img7 from '../images/img7.jpg';
import img8 from '../images/img8.jpg';
import img9 from '../images/img9.jpg';
import img10 from '../images/img10.jpg';
import img11 from '../images/img11.jpg';
import img12 from '../images/img12.jpg';
import img13 from '../images/img13.jpg';
import img14 from '../images/img14.jpg';
import img15 from '../images/img15.jpg';
import img16 from '../images/img16.jpg';
import img17 from '../images/img17.jpg';
import img18 from '../images/img18.jpg';
import img19 from '../images/img19.jpg';
import img20 from '../images/img20.jpg';
import img21 from '../images/img21.jpg';
import img22 from '../images/img22.jpg';
import img23 from '../images/img23.jpg';
import img24 from '../images/img24.jpg';
import img25 from '../images/img25.jpg';
import img26 from '../images/img26.jpg';
import img27 from '../images/img27.jpg';
import img28 from '../images/img28.jpg';
import img29 from '../images/img29.jpg';
import cert1 from '../images/cert1.jpg';
import cert2 from '../images/cert2.jpg';
import cert3 from '../images/cert3.png';


const Gallery = () => {
  const [language, setLanguage] = useState('en');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && ['mr', 'hi', 'en'].includes(savedLang)) {
      setLanguage(savedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const translations = {
    pageTitle: { mr: 'गॅलरी', hi: 'गैलरी', en: 'Gallery' },
    description: {
      mr: 'आमच्या ISO प्रमाणन प्रक्रिया, क्लायंट सक्सेस स्टोरीज आणि टीम अॅक्टिव्हिटीची झलक.',
      hi: 'हमारी ISO प्रमाणन प्रक्रिया, क्लाइंट सफलता कहानियाँ और टीम गतिविधियों की झलक।',
      en: 'A glimpse of our ISO certification processes, client success stories, and team activities.',
    },
    aboutCompany: { mr: 'कंपनीबद्दल', hi: 'कंपनी के बारे में', en: 'About Company' },
    address: { mr: '15A, नवजीवन कॉलोनी, वर्धा रोड, नरेंद्र नगर, नागपुर-440015', hi: '15A, नवजीवन कॉलोनी, वर्धा रोड, नरेंद्र नगर, नागपुर-440015', en: '15A, Navjivan Colony, Wardha Road, Narendra Nagar, Nagpur-440015' },
    usefulLinks: { mr: 'उपयोगी लिंक्स', hi: 'उपयोगी लिंक', en: 'Useful Links' },
    othersLinks: { mr: 'इतर लिंक्स', hi: 'अन्य लिंक', en: 'Other Links' },
    aboutUs: { mr: 'आमच्याबद्दल', hi: 'हमारे बारे में', en: 'About Us' },
    companyProfile: { mr: 'कंपनी प्रोफाईल', hi: 'कंपनी प्रोफाइल', en: 'Company Profile' },
    visionMission: { mr: 'व्हिजन मिशन', hi: 'विजन मिशन', en: 'Vision Mission' },
    clients: { mr: 'ग्राहक', hi: 'ग्राहक', en: 'Clients' },
    careers: { mr: 'करिअर', hi: 'करियर', en: 'Careers' },
    locations: { mr: 'स्थळे', hi: 'स्थान', en: 'Locations' },
    videoGallery: { mr: 'व्हिडिओ गॅलरी', hi: 'वीडियो गैलरी', en: 'Video Gallery' },
    photoGallery: { mr: 'फोटो गॅलरी', hi: 'फोटो गैलरी', en: 'Photo Gallery' },
    contactUs: { mr: 'संपर्क साधा', hi: 'संपर्क करें', en: 'Contact Us' },
    services: { mr: 'सेवा', hi: 'सेवाएँ', en: 'Services' },
    mailLogin: { mr: 'मेल लॉगिन', hi: 'मेल लॉगिन', en: 'Mail Login' },
    copyright: { mr: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सर्व हक्क राखीव।`, hi: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सर्वाधिकार सुरक्षित।`, en: `© ${new Date().getFullYear()} Global Certification. All Rights Reserved.` },
  };

  const t = (key) => translations[key][language] || translations[key]['en'];

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25, img26, img27, img28, img29,cert1,cert2,cert3];

  const openLightbox = (img) => {
    setSelectedImage(img);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const styles = {
    container: { 
      fontFamily: "'Poppins', sans-serif", 
      margin: 0, 
      padding: 0, 
      color: '#fff',
      minHeight: '100vh',
      backgroundColor: '#000',
    },
    hero: {
      height: '60vh',
      background: 'linear-gradient(rgba(0,0,0,0.92), rgba(0,0,0,0.92)), url("https://source.unsplash.com/random/1600x900/?certification,team")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '0 20px',
      position: 'relative',
    },
    heroTitle: { fontSize: '3.2rem', fontWeight: '700', margin: '0 0 12px 0', textShadow: '0 4px 12px rgba(0,0,0,0.6)', color: '#fff' },
    description: { fontSize: '1.15rem', maxWidth: '800px', margin: '0 auto 20px', lineHeight: '1.7', color: '#ddd' },
    languageSelect: {
      position: 'absolute', top: '30px', right: '30px', padding: '10px 20px', borderRadius: '30px',
      border: '2px solid #fff', backgroundColor: 'transparent', color: '#fff', fontSize: '16px',
      fontWeight: '600', cursor: 'pointer', outline: 'none', zIndex: 100,
    },
    section: { padding: '80px 40px', textAlign: 'center', maxWidth: '1400px', margin: '0 auto' },
    galleryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: '28px',
      justifyItems: 'center',
    },
    galleryItem: {
      position: 'relative', overflow: 'hidden', borderRadius: '16px',
      boxShadow: '0 10px 25px rgba(255,255,255,0.1)', cursor: 'pointer',
      transition: 'transform 0.4s ease, box-shadow 0.4s ease',
      width: '100%', maxWidth: '360px', backgroundColor: '#111',
    },
    galleryImg: {
      width: '100%', height: '260px', objectFit: 'cover', borderRadius: '16px',
      transition: 'transform 0.4s ease', display: 'block',
    },
    lightbox: {
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,0.97)', display: 'flex', alignItems: 'center',
      justifyContent: 'center', zIndex: 2000, opacity: lightboxOpen ? 1 : 0,
      visibility: lightboxOpen ? 'visible' : 'hidden', transition: 'opacity 0.4s ease, visibility 0.4s ease',
      padding: '20px',
    },
    lightboxImg: { maxWidth: '94%', maxHeight: '94%', borderRadius: '16px', boxShadow: '0 0 50px rgba(255,255,255,0.2)' },
    closeBtn: { position: 'absolute', top: '30px', right: '40px', color: '#fff', fontSize: '52px', fontWeight: '300', cursor: 'pointer', zIndex: 2001, userSelect: 'none', transition: 'color 0.3s' },

    // FOOTER - LIGHT PINK BACKGROUND
    footer: { 
      backgroundColor: '#ffebee',  // Light Pink
      color: '#333', 
      padding: '3rem 2rem 1.5rem', 
      borderTop: '1px solid #ffccbc'
    },
    footerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: '2rem',
      maxWidth: '1200px',
      margin: '0 auto 1.5rem',
    },
    footerCol: { minHeight: 'auto' },
    footerH4: { 
      color: '#d32f2f', 
      marginBottom: '0.8rem', 
      fontSize: '1.05rem', 
      paddingBottom: '0.4rem', 
      position: 'relative',
      fontWeight: '700'
    },
    footerH4After: { 
      content: '""', 
      position: 'absolute', 
      bottom: 0, 
      left: 0, 
      width: '35px', 
      height: '2.5px', 
      backgroundColor: '#ff5252' 
    },
    fLink: { 
      display: 'block', 
      marginBottom: '0.45rem', 
      fontSize: '0.92rem', 
      color: '#555', 
      textDecoration: 'none', 
      transition: 'color 0.3s',
      fontWeight: '500'
    },
    copyright: { 
      fontSize: '0.88rem', 
      paddingTop: '1.2rem', 
      color: '#777',
      fontWeight: '500'
    },

    whatsappBtn: {
      position: 'fixed', bottom: '25px', left: '25px', backgroundColor: '#25D366',
      padding: '16px', borderRadius: '50%', boxShadow: '0 6px 16px rgba(0,0,0,0.4)',
      zIndex: 1000, transition: 'transform 0.3s ease',
    },
    whatsappImg: { width: '36px', filter: 'brightness(0) invert(1)' },
  };

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      {/* <section style={styles.hero}>
        <h1 style={styles.heroTitle}>{t('pageTitle')}</h1>
        <p style={styles.description}>{t('description')}</p>
        <select value={language} onChange={(e) => changeLanguage(e.target.value)} style={styles.languageSelect}>
          <option value="mr">मराठी</option>
          <option value="hi">हिन्दी</option>
          <option value="en">English</option>
        </select>
      </section> */}

      {/* Gallery Grid */}
      <section style={styles.section}>
        <div style={styles.galleryGrid}>
          {images.map((img, i) => (
            <div
              key={i}
              style={styles.galleryItem}
              onClick={() => openLightbox(img)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(255,127,80,0.3)';
                e.currentTarget.querySelector('img').style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = '';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(255,255,255,0.1)';
                e.currentTarget.querySelector('img').style.transform = 'scale(1)';
              }}
            >
              <img src={img} alt={`Gallery ${i + 1}`} style={styles.galleryImg} />
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && (
        <div style={styles.lightbox} onClick={closeLightbox}>
          <span 
            style={styles.closeBtn}
            onClick={closeLightbox}
            onMouseEnter={(e) => e.target.style.color = '#FF7F50'}
            onMouseLeave={(e) => e.target.style.color = '#fff'}
          >×</span>
          {selectedImage && <img src={selectedImage} alt="Enlarged" style={styles.lightboxImg} />}
        </div>
      )}

      {/* FOOTER - LIGHT PINK */}
      <footer style={styles.footer}>
        <div style={styles.footerGrid}>
          {/* About Company */}
          <div style={styles.footerCol}>
            <h4 style={styles.footerH4}>
              {t('aboutCompany')}
              <span style={styles.footerH4After}></span>
            </h4>
            <p style={{ color: '#444', fontSize: '0.9rem', lineHeight: '1.6' }}>
              Global Certification<br />
              {t('address')}
            </p>
          </div>

          {/* Useful Links */}
          <div style={styles.footerCol}>
            <h4 style={styles.footerH4}>
              {t('usefulLinks')}
              <span style={styles.footerH4After}></span>
            </h4>
            <Link to="/about-us" style={styles.fLink}>{t('aboutUs')}</Link>
            <Link to="/about-us" style={styles.fLink}>{t('companyProfile')}</Link>
            <Link to="/vision-mission" style={styles.fLink}>{t('visionMission')}</Link>
          </div>

          {/* Other Links */}
          <div style={styles.footerCol}>
            <h4 style={styles.footerH4}>
              {t('othersLinks')}
              <span style={styles.footerH4After}></span>
            </h4>
            
            
            <Link to="/contact-us" style={styles.fLink}>{t('locations')}</Link>
            <Link to="/contact-us" style={styles.fLink}>{t('contactUs')}</Link>
            <Link to="/iso-standards" style={styles.fLink}>{t('services')}</Link>
            
          </div>
        </div>
        <p style={styles.copyright}>{t('copyright')}</p>
      </footer>

      {/* WhatsApp */}
      <a 
        href="https://wa.me/919975977462" 
        target="_blank" 
        rel="noopener noreferrer" 
        style={styles.whatsappBtn}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <img src={whatsapp} alt="WhatsApp" style={styles.whatsappImg} />
      </a>
    </div>
  );
};

export default Gallery;